import DealsLanding from '@/features/deals/pages/DealsLanding/DealsLanding';
import withDealsFeatureFlag from '@/features/deals/withDealsFeatureFlag';

export default withDealsFeatureFlag(DealsLanding);
